import { Can } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { useDiscountSlabs } from '@/features/configuration-management/discount-management/hooks/useDiscountSlabs';
import { DiscountSlabsTable } from '@/features/configuration-management/discount-management/slab/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['fromAmount', 'toAmount', 'discountType', 'value', 'minValue', 'maxValue']),
  desc: z.boolean(),
});

const SlabSearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
    q: z
      .any()
      .optional()
      .transform((val) => (val == null ? undefined : String(val))),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/configuration-management/discount-management/$discountCategory/')({
  component: RouteComponent,

  validateSearch: (search: SearchSchemaInput) => SlabSearchSchema.parse(search),
});

function RouteComponent() {
  const { discountCategory } = Route.useParams();
  const { slabs, isLoading, meta } = useDiscountSlabs(discountCategory);

  return (
    <Can rule={{ allOf: [PERMS.discount.category.detailList] }}>
      <DiscountSlabsTable data={slabs || []} isLoading={isLoading} pagination={meta} />
    </Can>
  );
}
